/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BillAnalyticParamRequest } from '../model';
// @ts-ignore
import { GetValuableUserResult } from '../model';
// @ts-ignore
import { GoogleBillAnalyticParamRequest } from '../model';
// @ts-ignore
import { Radar361BillAnalyticParamRequest } from '../model';
// @ts-ignore
import { SafarMarketBillAnalyticParamRequest } from '../model';
// @ts-ignore
import { TakhfifanBillAnalyticParamRequest } from '../model';
// @ts-ignore
import { WebEngageBillAnalyticParamRequest } from '../model';
/**
 * AnalyticsApiApiAnalyticsAdtraceBillCodePost - axios parameter creator
 * 
 * @summary adds in adtrace analytic params via bill code
 * @param {string} billCode 
 * @param {BillAnalyticParamRequest} [billAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsAdtraceBillCodePostAxiosParamCreator (billCode: string, billAnalyticParamRequest?: BillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsAdtraceBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/adtrace/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(billAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsFirebaseBillCodePost - axios parameter creator
 * 
 * @summary adds in firebase params via bill code
 * @param {string} billCode 
 * @param {GoogleBillAnalyticParamRequest} [googleBillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsFirebaseBillCodePostAxiosParamCreator (billCode: string, googleBillAnalyticParamRequest?: GoogleBillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsFirebaseBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/firebase/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(googleBillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsGetPromAlertDataGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsGetPromAlertDataGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/analytics/GetPromAlertData`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePost - axios parameter creator
 * 
 * @summary adds in google analytic params via bill code
 * @param {string} billCode 
 * @param {GoogleBillAnalyticParamRequest} [googleBillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostAxiosParamCreator (billCode: string, googleBillAnalyticParamRequest?: GoogleBillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsGoogleAnalyticsBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/google-analytics/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(googleBillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsMetrixBillCodePost - axios parameter creator
 * 
 * @summary adds in metrix analytic params via bill code
 * @param {string} billCode 
 * @param {BillAnalyticParamRequest} [billAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsMetrixBillCodePostAxiosParamCreator (billCode: string, billAnalyticParamRequest?: BillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsMetrixBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/metrix/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(billAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsMetrixCallbackGet - axios parameter creator
 * 
 * @summary Get event callback from metrix and registers into database
 * @param {string} [eventName] 
 * @param {string} [androidId] 
 * @param {string} [gpsAdid] 
 * @param {string} [deviceName] 
 * @param {string} [deviceManufacturer] 
 * @param {string} [installedAt] 
 * @param {string} [clickedAt] 
 * @param {string} [ipAddress] 
 * @param {string} [trackerCode] 
 * @param {string} [networkName] 
 * @param {string} [campaignName] 
 * @param {string} [adgroupName] 
 * @param {string} [creativeName] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsMetrixCallbackGetAxiosParamCreator (eventName?: string, androidId?: string, gpsAdid?: string, deviceName?: string, deviceManufacturer?: string, installedAt?: string, clickedAt?: string, ipAddress?: string, trackerCode?: string, networkName?: string, campaignName?: string, adgroupName?: string, creativeName?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/analytics/metrix/callback`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (eventName !== undefined) {
        localVarQueryParameter['EventName'] = eventName;
    }

    if (androidId !== undefined) {
        localVarQueryParameter['AndroidId'] = androidId;
    }

    if (gpsAdid !== undefined) {
        localVarQueryParameter['GpsAdid'] = gpsAdid;
    }

    if (deviceName !== undefined) {
        localVarQueryParameter['DeviceName'] = deviceName;
    }

    if (deviceManufacturer !== undefined) {
        localVarQueryParameter['DeviceManufacturer'] = deviceManufacturer;
    }

    if (installedAt !== undefined) {
        localVarQueryParameter['InstalledAt'] = installedAt;
    }

    if (clickedAt !== undefined) {
        localVarQueryParameter['ClickedAt'] = clickedAt;
    }

    if (ipAddress !== undefined) {
        localVarQueryParameter['IpAddress'] = ipAddress;
    }

    if (trackerCode !== undefined) {
        localVarQueryParameter['TrackerCode'] = trackerCode;
    }

    if (networkName !== undefined) {
        localVarQueryParameter['NetworkName'] = networkName;
    }

    if (campaignName !== undefined) {
        localVarQueryParameter['CampaignName'] = campaignName;
    }

    if (adgroupName !== undefined) {
        localVarQueryParameter['AdgroupName'] = adgroupName;
    }

    if (creativeName !== undefined) {
        localVarQueryParameter['CreativeName'] = creativeName;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsRadar361BillCodePost - axios parameter creator
 * 
 * @summary adds in radar361 analytic params via bill code
 * @param {string} billCode 
 * @param {Radar361BillAnalyticParamRequest} [radar361BillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsRadar361BillCodePostAxiosParamCreator (billCode: string, radar361BillAnalyticParamRequest?: Radar361BillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsRadar361BillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/radar361/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(radar361BillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsSafarmarketBillCodePost - axios parameter creator
 * 
 * @summary adds in safar market analytic params via bill code
 * @param {string} billCode 
 * @param {SafarMarketBillAnalyticParamRequest} [safarMarketBillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsSafarmarketBillCodePostAxiosParamCreator (billCode: string, safarMarketBillAnalyticParamRequest?: SafarMarketBillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsSafarmarketBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/safarmarket/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(safarMarketBillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsTakhfifanBillCodePost - axios parameter creator
 * 
 * @summary adds in takhfifan analytic params via bill code
 * @param {string} billCode 
 * @param {TakhfifanBillAnalyticParamRequest} [takhfifanBillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsTakhfifanBillCodePostAxiosParamCreator (billCode: string, takhfifanBillAnalyticParamRequest?: TakhfifanBillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsTakhfifanBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/takhfifan/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(takhfifanBillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsValuableUserIdsGet - axios parameter creator
 * 
 * @summary adds in webengage analytic params via bill code
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsValuableUserIdsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/analytics/valuableUserIds`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AnalyticsApiApiAnalyticsWebengageBillCodePost - axios parameter creator
 * 
 * @summary adds in webengage analytic params via bill code
 * @param {string} billCode 
 * @param {WebEngageBillAnalyticParamRequest} [webEngageBillAnalyticParamRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AnalyticsApiApiAnalyticsWebengageBillCodePostAxiosParamCreator (billCode: string, webEngageBillAnalyticParamRequest?: WebEngageBillAnalyticParamRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAnalyticsWebengageBillCodePost', 'billCode', billCode)
    const localVarPath = `/api/analytics/webengage/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(webEngageBillAnalyticParamRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAnalyticsAdtraceBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsAdtraceBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsAdtraceBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsAdtraceBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {BillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsAdtraceBillCodePost
     */
    readonly billAnalyticParamRequest?: BillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsFirebaseBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsFirebaseBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsFirebaseBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsFirebaseBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {GoogleBillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsFirebaseBillCodePost
     */
    readonly googleBillAnalyticParamRequest?: GoogleBillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsGoogleAnalyticsBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {GoogleBillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePost
     */
    readonly googleBillAnalyticParamRequest?: GoogleBillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsMetrixBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsMetrixBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsMetrixBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {BillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsMetrixBillCodePost
     */
    readonly billAnalyticParamRequest?: BillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsMetrixCallbackGet operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsMetrixCallbackGetRequest
 */
export interface AnalyticsApiApiAnalyticsMetrixCallbackGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly eventName?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly androidId?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly gpsAdid?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly deviceName?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly deviceManufacturer?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly installedAt?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly clickedAt?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly ipAddress?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly trackerCode?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly networkName?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly campaignName?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly adgroupName?: string

    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsMetrixCallbackGet
     */
    readonly creativeName?: string
}

/**
 * Request parameters for apiAnalyticsRadar361BillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsRadar361BillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsRadar361BillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsRadar361BillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {Radar361BillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsRadar361BillCodePost
     */
    readonly radar361BillAnalyticParamRequest?: Radar361BillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsSafarmarketBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsSafarmarketBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsSafarmarketBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsSafarmarketBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {SafarMarketBillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsSafarmarketBillCodePost
     */
    readonly safarMarketBillAnalyticParamRequest?: SafarMarketBillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsTakhfifanBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsTakhfifanBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsTakhfifanBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsTakhfifanBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {TakhfifanBillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsTakhfifanBillCodePost
     */
    readonly takhfifanBillAnalyticParamRequest?: TakhfifanBillAnalyticParamRequest
}

/**
 * Request parameters for apiAnalyticsWebengageBillCodePost operation in AnalyticsApi.
 * @export
 * @interface AnalyticsApiApiAnalyticsWebengageBillCodePostRequest
 */
export interface AnalyticsApiApiAnalyticsWebengageBillCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsApiApiAnalyticsWebengageBillCodePost
     */
    readonly billCode: string

    /**
     * 
     * @type {WebEngageBillAnalyticParamRequest}
     * @memberof AnalyticsApiApiAnalyticsWebengageBillCodePost
     */
    readonly webEngageBillAnalyticParamRequest?: WebEngageBillAnalyticParamRequest
}

/**
* 
* @summary adds in adtrace analytic params via bill code
* @param {AnalyticsApiApiAnalyticsAdtraceBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsAdtraceBillCodePost(requestParameters: AnalyticsApiApiAnalyticsAdtraceBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsAdtraceBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.billAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in firebase params via bill code
* @param {AnalyticsApiApiAnalyticsFirebaseBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsFirebaseBillCodePost(requestParameters: AnalyticsApiApiAnalyticsFirebaseBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsFirebaseBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.googleBillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsGetPromAlertDataGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsGetPromAlertDataGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<string>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in google analytic params via bill code
* @param {AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePost(requestParameters: AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsGoogleAnalyticsBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.googleBillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in metrix analytic params via bill code
* @param {AnalyticsApiApiAnalyticsMetrixBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsMetrixBillCodePost(requestParameters: AnalyticsApiApiAnalyticsMetrixBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsMetrixBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.billAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get event callback from metrix and registers into database
* @param {AnalyticsApiApiAnalyticsMetrixCallbackGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsMetrixCallbackGet(requestParameters: AnalyticsApiApiAnalyticsMetrixCallbackGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsMetrixCallbackGetAxiosParamCreator(requestParameters.eventName, requestParameters.androidId, requestParameters.gpsAdid, requestParameters.deviceName, requestParameters.deviceManufacturer, requestParameters.installedAt, requestParameters.clickedAt, requestParameters.ipAddress, requestParameters.trackerCode, requestParameters.networkName, requestParameters.campaignName, requestParameters.adgroupName, requestParameters.creativeName, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in radar361 analytic params via bill code
* @param {AnalyticsApiApiAnalyticsRadar361BillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsRadar361BillCodePost(requestParameters: AnalyticsApiApiAnalyticsRadar361BillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsRadar361BillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.radar361BillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in safar market analytic params via bill code
* @param {AnalyticsApiApiAnalyticsSafarmarketBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsSafarmarketBillCodePost(requestParameters: AnalyticsApiApiAnalyticsSafarmarketBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsSafarmarketBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.safarMarketBillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in takhfifan analytic params via bill code
* @param {AnalyticsApiApiAnalyticsTakhfifanBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsTakhfifanBillCodePost(requestParameters: AnalyticsApiApiAnalyticsTakhfifanBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsTakhfifanBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.takhfifanBillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in webengage analytic params via bill code
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsValuableUserIdsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsValuableUserIdsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GetValuableUserResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary adds in webengage analytic params via bill code
* @param {AnalyticsApiApiAnalyticsWebengageBillCodePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AnalyticsApiApiAnalyticsWebengageBillCodePost(requestParameters: AnalyticsApiApiAnalyticsWebengageBillCodePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AnalyticsApiApiAnalyticsWebengageBillCodePostAxiosParamCreator(requestParameters.billCode, requestParameters.webEngageBillAnalyticParamRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
